import React from 'react'
import styled from '@emotion/styled'
import { ValidatedInput, SUI } from 'shared/ui'

const SuifyiedValidatedInput = ({ className, ...rest }) => (
  <SUI className={className}>
    <ValidatedInput {...rest} />
  </SUI>
)

const Input = styled(SuifyiedValidatedInput)`
  width: 100%;
`
const InlineInput = styled(Input)`
  margin-left: 0;
  margin-right: ${props => props.theme.spacing['7']};
  width: 192px !important;
`

const Error = styled('div')`
  margin-top: ${props => props.theme.spacing['3']};
  color: ${props => props.theme.color.primary.negative};
`

function SUIInput(props) {
  const { className, error, forwardRef, focused, ...rest } = props
  return (
    <div>
      <InlineInput
        type="search"
        autoComplete="off"
        autoCapitalize="off"
        autoCorrect="off"
        autoFocus={focused}
        spellCheck="off"
        className={className}
        error={error}
        forwardRef={forwardRef}
        fluid
        {...rest}
      />
      {error && <Error>{error}</Error>}
    </div>
  )
}

const OldSearchBox = styled(({ className, forwardRef, ...rest }) => {
  return (
    <input
      type="search"
      autoComplete="off"
      autoCapitalize="off"
      autoCorrect="off"
      spellCheck="off"
      className={className}
      ref={forwardRef}
      tabIndex="-1"
      {...rest}
    />
  )
})`
  background-color: inherit;
  border: 0;
  color: ${props =>
    props.sui ? props.theme.color.monochrome.dark : 'inherit'};
  flex-grow: 1;
  font: inherit;
  margin: 0;
  min-width: 200px;
  width: 100%;
  outline: 0;
  padding: 0;

  &&& {
    margin: 0 -8px 0 0;
    padding: 0 8px;
    line-height: 26px;
  }

  &:focus {
    color: ${props => (props.sui ? props.theme.color.monochrome.black : '')};
  }

  ::placeholder {
    color: ${props =>
      props.sui
        ? props.theme.color.monochrome.mediumDark
        : 'hsla(0, 0%, 75%, 1)'};
  }
`

export default function SearchBox({ sui, multiple, ...rest }) {
  if (sui && !multiple) return <SUIInput {...rest} />

  return <OldSearchBox {...rest} />
}
